﻿import $ from 'jquery';
import { Element } from './element';
import _ from 'underscore';

export class ToggleValue {
  public static wireupDocument: Function = _.once(() => {
    $(document).on('toggled.rustig.togglestate', '[data-ts-command="value"]', function () {
      let htmlElement = this as HTMLElement;
      let element = Element.from(htmlElement);

      let value1 = element.isCheckbox ? htmlElement.getAttribute('data-value-1').toBoolean() : htmlElement.getAttribute('data-value-1');
      let value2 = element.isCheckbox ? htmlElement.getAttribute('data-value-2').toBoolean() : htmlElement.getAttribute('data-value-2');

      if (element.value() === value1)
        element.value(value2);
      else
        element.value(value1);
    });

    $(document).on('toggled.rustig.togglestate', '[data-ts-command="value-by-selector"]', function () {
      let htmlElement = this as HTMLElement;
      let getValue = function (attribute: string): string {
        let selector = htmlElement.getAttribute(attribute);
        let element = document.querySelector(selector) as HTMLElement;
        return Element.from(element).value();
      }

      let value1 = getValue('data-value-1');
      let value2 = getValue('data-value-2');

      let element = Element.from(htmlElement);
      if (element.value() === value1)
        element.value(value2);
      else
        element.value(value1);
    });
  });
}